import React from 'react';

import { Button } from '../button/button';
import { NEW_WINDOW_FEATURES, SHARE_URLS } from './contants';

export type SocialShareButtonProps = {
  target: keyof typeof SHARE_URLS;
  url: string;
  className?: string;
};

export const SocialShareButton: React.FC<SocialShareButtonProps> = ({
  children,
  className,
  target,
  url,
}) => {
  const onClick = () => {
    window.open(`${SHARE_URLS[target]}${url}`, 'window', NEW_WINDOW_FEATURES);
  };

  return (
    <Button className={className} onClick={onClick}>
      {children}
    </Button>
  );
};
